import type { QCResultStatsResult } from "@/modules/qc/domain/types/result";
import { Card } from "@devhop/ui";
import { AlertTriangle, CheckCircle, Clock } from "lucide-react";

type QCResultStatsCardsProps = {
  stats: QCResultStatsResult;
};

export function QCResultStatsCards({ stats }: QCResultStatsCardsProps) {
  const passRate =
    stats.overall.total > 0
      ? Math.round((stats.overall.pass / stats.overall.total) * 100)
      : 0;
  const failRate =
    stats.overall.total > 0
      ? Math.round((stats.overall.fail / stats.overall.total) * 100)
      : 0;

  return (
    <div
      className="grid grid-cols-1 gap-4 md:grid-cols-4"
      data-tourid="result-stats-cards"
    >
      <Card className="p-6">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-muted-foreground text-sm">ທັງໝົດ</p>
            <p className="mt-1 font-bold text-3xl">{stats.overall.total}</p>
          </div>
          <div className="rounded-full bg-primary/10 p-3">
            <Clock className="h-6 w-6 text-primary" />
          </div>
        </div>
      </Card>

      <Card className="p-6">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-muted-foreground text-sm">ຜ່ານ</p>
            <p className="mt-1 font-bold text-3xl text-green-600">
              {stats.overall.pass}
            </p>
            <p className="text-muted-foreground text-xs">{passRate}%</p>
          </div>
          <div className="rounded-full bg-green-500/10 p-3">
            <CheckCircle className="h-6 w-6 text-green-600" />
          </div>
        </div>
      </Card>

      <Card className="p-6">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-muted-foreground text-sm">ບໍ່ຜ່ານ</p>
            <p className="mt-1 font-bold text-3xl text-red-600">
              {stats.overall.fail}
            </p>
            <p className="text-muted-foreground text-xs">{failRate}%</p>
          </div>
          <div className="rounded-full bg-red-500/10 p-3">
            <AlertTriangle className="h-6 w-6 text-red-600" />
          </div>
        </div>
      </Card>

      <Card className="p-6">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-muted-foreground text-sm">ກຳລັງກວດສອບ</p>
            <p className="mt-1 font-bold text-3xl text-yellow-600">
              {stats.overall.pending}
            </p>
          </div>
          <div className="rounded-full bg-yellow-500/10 p-3">
            <Clock className="h-6 w-6 text-yellow-600" />
          </div>
        </div>
      </Card>
    </div>
  );
}
